import { render, staticRenderFns } from "./inspectDetail.vue?vue&type=template&id=a1937138&scoped=true&"
import script from "./inspectDetail.vue?vue&type=script&lang=js&"
export * from "./inspectDetail.vue?vue&type=script&lang=js&"
import style0 from "./inspectDetail.vue?vue&type=style&index=0&id=a1937138&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1937138",
  null
  
)

export default component.exports